export const LinkedinGradientImage = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.75 4C2.75 3.30964 3.30964 2.75 4 2.75C4.69036 2.75 5.25 3.30964 5.25 4C5.25 4.69036 4.69036 5.25 4 5.25C3.30964 5.25 2.75 4.69036 2.75 4ZM4 1.25C2.48122 1.25 1.25 2.48122 1.25 4C1.25 5.51878 2.48122 6.75 4 6.75C5.51878 6.75 6.75 5.51878 6.75 4C6.75 2.48122 5.51878 1.25 4 1.25ZM16 8.75C14.6076 8.75 13.2723 9.30312 12.2877 10.2877C11.3031 11.2723 10.75 12.6076 10.75 14V20.25H13.25V14C13.25 13.2707 13.5397 12.5712 14.0555 12.0555C14.5712 11.5397 15.2707 11.25 16 11.25C16.7293 11.25 17.4288 11.5397 17.9445 12.0555C18.4603 12.5712 18.75 13.2707 18.75 14V20.25H21.25V14C21.25 12.6076 20.6969 11.2723 19.7123 10.2877C18.7277 9.30312 17.3924 8.75 16 8.75ZM11.227 9.22703C12.4929 7.96116 14.2098 7.25 16 7.25C17.7902 7.25 19.5071 7.96116 20.773 9.22703C22.0388 10.4929 22.75 12.2098 22.75 14V21C22.75 21.4142 22.4142 21.75 22 21.75H18C17.5858 21.75 17.25 21.4142 17.25 21V14C17.25 13.6685 17.1183 13.3505 16.8839 13.1161C16.6495 12.8817 16.3315 12.75 16 12.75C15.6685 12.75 15.3505 12.8817 15.1161 13.1161C14.8817 13.3505 14.75 13.6685 14.75 14V21C14.75 21.4142 14.4142 21.75 14 21.75H10C9.58579 21.75 9.25 21.4142 9.25 21V14C9.25 12.2098 9.96116 10.4929 11.227 9.22703ZM1.25 9C1.25 8.58579 1.58579 8.25 2 8.25H6C6.41421 8.25 6.75 8.58579 6.75 9V21C6.75 21.4142 6.41421 21.75 6 21.75H2C1.58579 21.75 1.25 21.4142 1.25 21V9ZM2.75 9.75V20.25H5.25V9.75H2.75Z"
      fill="url(#paint0_linear_10075_167815)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_10075_167815"
        x1="1.25"
        y1="1.24998"
        x2="25.8151"
        y2="6.04392"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0E4ED7" />
        <stop offset="0.484375" stopColor="#7B4B93" />
        <stop offset="1" stopColor="#F94743" />
      </linearGradient>
    </defs>
  </svg>
);
